import { useRef, useEffect, useCallback } from 'react'
import { ArrowLeftRight } from 'lucide-react'
import { ActionPopover } from './wrappers/ActionPopover'
import { SwapContent } from './content/SwapContent'

interface SwapPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onMobileClick?: () => void
  isActive?: boolean
}

export function SwapPopover({ open, onOpenChange, onMobileClick, isActive }: SwapPopoverProps) {
  const prevOpenRef = useRef(open)
  const contentResetRef = useRef<(() => void) | null>(null)

  const handleSetContentReset = useCallback((resetFn: () => void) => {
    contentResetRef.current = resetFn
  }, [])

  useEffect(() => {
    if (prevOpenRef.current === true && open === false) {
      contentResetRef.current?.()
    }
    prevOpenRef.current = open
  }, [open])

  return (
    <ActionPopover
      open={open}
      onOpenChange={onOpenChange}
      trigger={<ArrowLeftRight className="w-8 h-8" />}
      onMobileClick={onMobileClick}
      isActive={isActive}
    >
      <SwapContent onSetReset={handleSetContentReset} />
    </ActionPopover>
  )
}
